import { NgModule } from '@angular/core';
import { NgxImageengineComponent } from './ngx-imageengine.component';
import { BrowserModule } from "@angular/platform-browser";


@NgModule({
  declarations: [
    NgxImageengineComponent
  ],
    imports: [
	BrowserModule
  ],
  exports: [
    NgxImageengineComponent
  ]
})
export class NgxImageengineModule { }
